import parse from 'html-react-parser';
import React from 'react';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import { Children, Container } from './styles';

export type IContent = {
  title: string | null;
  children: string | React.ReactNode;
  subject: subjectTypes | string;
  isLesson?: boolean;
};

export default function WrapContent({
  title,
  children,
  subject,
  isLesson = false
}: IContent) {
  if (title === 'Fonte') return null;

  return (
    <Container title={title}>
      <Children
        $iscompetences={false}
        $subject={subject}
        $isbncc={false}
        $islesson={isLesson}
      >
        {typeof children === 'string' ? parse(children) : children}
      </Children>
    </Container>
  );
}
